module.exports = __webpack_public_path__ + "static/img/feature_distributor.c2b6e0a6.png";